var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{key:`chip-${_vm.data.item.id}`,staticClass:"chip--select-multi",attrs:{"value":_vm.data.selected,"close":false}},[_c('avatar',{key:`avatar-${_vm.data.item.id}`,attrs:{"icon":_vm.data.item.avatar,"size":"32px"}}),_vm._v(" "+_vm._s(_vm.data.item.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }